import API from './axios.js';


//companybyid
export const getCompanyDataByID = (id) => API.get(`company/${id}`);